import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-err404page',
  templateUrl: './err404page.component.html',
  styleUrls: ['./err404page.component.scss']
})
export class Err404pageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
